import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { slugify } from '../../../utils/slugify';

// components
import { FormattedNumber } from 'react-intl';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

//styles
import styles from './SbSharedRefineMenuLink.scss';

export function SbSharedRefineMenuLink(props) {
    const {
        text,
        count,
        onClick,
        seoLink,
        className,
        shouldIndent,
        dataTn,
        selected,
        isHidden,
    } = props;

    const containerClass = classnames(styles.container, className, {
        [styles.selected]: selected,
        [styles.indent]: shouldIndent,
        'is-hidden': isHidden,
    });

    return (
        <div
            onClick={onClick}
            className={containerClass}
            data-tn={`facet-link${selected ? '-selected' : ''}`}
        >
            <AbsoluteAnchor href={seoLink}>
                <span className={styles.text} data-tn={`facet-content-${slugify(dataTn || text)}`}>
                    {text}
                </span>
            </AbsoluteAnchor>
            {!!count && (
                <span className={styles.count} data-tn={`facet-count-${slugify(dataTn || text)}`}>
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuLink.propTypes = {
    count: PropTypes.number,
    selected: PropTypes.bool,
    dataTn: PropTypes.string,
    seoLink: PropTypes.string,
    className: PropTypes.string,
    shouldIndent: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    isHidden: PropTypes.bool,
};
